import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import Course from './Course';
import CourseUnycos from './CourseUnycos';

function RelatedCourse({ item, source, campaign, medium, buttonText, layout }) {
  let articleUrl = '';
  if (item.alternative_url) {
    articleUrl = [item.alternative_url];
  } else {
    articleUrl = ['courseUrl', item.slug];
  }
  const instructorsName = item.instructors.map(
    (instructor) => instructor.displayName
  );
  const categoriesName = item.categories.map((category) => category.name);
  const style = item.campaign
    && item.campaign.discount && dayjs(item.campaign.start).isBefore(dayjs()) ? {} : { visibility: 'hidden' };

  if (layout === 'unycos') {
    return (
      <CourseUnycos
        articleUrl={articleUrl}
        source={source}
        campaign={campaign}
        medium={medium}
        categoriesName={categoriesName}
        item={item}
        instructorsName={instructorsName}
        style={style}
        buttonText={buttonText}
      />
    );
  }

  return (
    <Course
      articleUrl={articleUrl}
      source={source}
      campaign={campaign}
      medium={medium}
      categoriesName={categoriesName}
      item={item}
      instructorsName={instructorsName}
      style={style}
      buttonText={buttonText}
    />
  );
}

RelatedCourse.propTypes = {
  campaign: PropTypes.string,
  source: PropTypes.string,
  medium: PropTypes.string,
  item: PropTypes.object,
  buttonText: PropTypes.string,
  layout: PropTypes.string,
};

export default RelatedCourse;
